import { render, staticRenderFns } from "./ECommerceAddCourse.vue?vue&type=template&id=572fa299&scoped=true&"
import script from "./ECommerceAddCourse.vue?vue&type=script&lang=js&"
export * from "./ECommerceAddCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572fa299",
  null
  
)

export default component.exports